import React, { useState } from "react";
import AllHero from "../../components/Admin/Hero Section/AllHero";
import AddHeroModal from "../../components/Admin/Hero Section/AddHeroModal";

const HeroSection = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleRefresh = () => setRefresh((prev) => !prev);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Hero Section</h1>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          className="flex items-center gap-2 bg-primaryColor  text-white px-5 py-2.5 rounded-lg font-medium transition"
        >
          <span className="text-xl leading-none">+</span> Add Hero Section
        </button>
      </div>

      <AllHero refresh={refresh} onRefresh={handleRefresh} />

      {showAddModal && (
        <AddHeroModal
          onClose={() => setShowAddModal(false)}
          onSuccess={() => {
            setShowAddModal(false);
            handleRefresh();
          }}
        />
      )}
    </div>
  );
};

export default HeroSection;
